import React from 'react'
import { connect } from 'react-redux'

import { Field } from 'redux-form'
import { Fade } from '@material-ui/core'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard } from 'components'
import { ProcessRow } from '../ProcessHistory/ProcessRow'

import { ProcurementBody } from '../../../styled'
import { SummaryContainer } from './styled'

const Summary = props => {

  const {
    sapDetails
  } = props

  const setLastComment = () => {
    if(sapDetails&&sapDetails.rfqComments.length>0){
      return (
      <div style={{marginTop:'1rem'}}>
        <div style={{fontWeight:'bold'}}>Last Comment</div>
        <div style={{marginTop:'1rem',flex:1}}>
          <ProcessRow 
          data={sapDetails.rfqComments[0]} 
          files={sapDetails.rfqAttachments.filter(x=>x.commentId===sapDetails.rfqComments[sapDetails.rfqComments.length-1].id)}/>
        </div>
      </div>)
    }
    return null
  }

  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <StdCard title="Summary Information">
          <SummaryContainer>
            <div className="rowFields">
              <Field
                name="selectedVendor"
                label="Choose Vendor"
                type={type.text}
                component={FieldInput}
                editable={false}
              />
            </div>
            <div className="rowFields">
              <Field
                name="selectedRfqNo"
                label="RFQ No."
                className="halfRow"
                type={type.text}
                component={FieldInput}
                editable={false}
              />
            </div>
            <div className="rowFields">
              <Field
                name="totalAmount"
                label="Total Amount"
                className="halfRow"
                fixedDecimalScale
                suffix={sapDetails?`  ${sapDetails.currencyCode}`:''}
                decimalScale={2} 
                type={type.number}
                component={FieldInput}
                editable={false}
              />
            </div>
            <div className="rowFields">
              <Field
                name="discount"
                label="Discount"
                className="halfRow"
                fixedDecimalScale
                suffix={sapDetails?`  ${sapDetails.currencyCode}`:''}
                decimalScale={2} 
                type={type.number}
                component={FieldInput}
                editable={false}
              />
            </div>
            <div className="rowFields">
              <Field
                name="amountAfterDiscount"
                label="After Discount Amount"
                className="halfRow"
                type={type.number}
                fixedDecimalScale
                suffix={sapDetails?`  ${sapDetails.currencyCode}`:''}
                decimalScale={2} 
                component={FieldInput}
                editable={false}
              />
            </div>
            <div className="rowFields">
              <Field
                name="vatAmount"
                label={`Vat ${sapDetails?`${sapDetails.vatRate}%`:''}`}
                suffix={sapDetails?`  ${sapDetails.currencyCode}`:''}
                decimalScale={2} 
                className="halfRow"
                fixedDecimalScale
                type={type.number}
                component={FieldInput}
                editable={false}
              />
            </div>
            <div className="rowFields">
              <Field
                name="netAmount"
                label="Net Amount"
                fixedDecimalScale
                className="halfRow"
                type={type.number}
                suffix={sapDetails?`  ${sapDetails.currencyCode}`:''}
                decimalScale={2} 
                component={FieldInput}
                editable={false}
              />
            </div>
            {setLastComment()}
          </SummaryContainer>
        </StdCard>
      </ProcurementBody>
    </Fade>
  )
}
const mapStateToProps = (state, props) => {
  return {
    sapDetails: state.rfq.sapDetails.data
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Summary)
